'use client'

import { getProviders, signIn, useSession } from 'next-auth/react';
import { redirect } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';

import { cn } from '@/util';
import { motion } from 'framer-motion';
import { isNil } from 'lodash';
import { Suspense } from 'react';
import { FaArrowRightToBracket, FaCheck, FaChrome, FaSpinner } from 'react-icons/fa6';
import OtpInput from 'react-otp-input';
import NavBar from '@/app/_components/nav-bar';

import {
    InputOTP,
    InputOTPGroup,
    InputOTPSeparator,
    InputOTPSlot,
} from "@/components/ui/input-otp"
import { REGEXP_ONLY_DIGITS } from 'input-otp';

interface Provider {
    id: string;
    name: string;
    type: string;
    [k: string]: string;
}

interface SigninPageProps {
    isLoggedIn: boolean;
    providers: Array<Provider>;
    csrfToken: string;
}





const SigninPage = () => {
    // const query = useSearchParams();
    // const error = query.get('error');

    const session = useSession()


    useEffect(() => {
        console.log("session/", session)
        if (session.status == 'loading') return;
        if (session.status == 'authenticated') {
            redirect("/")
            return;
        }

    }, [session])


    // if (session) {
    //     if (session.status == 'authenticated') {
    //         console.log("User logged in alread");


    //         redirect("/")
    //     }
    // }

    const [providers, setProviders] = useState<any[]>([])
    const [otp, setOtp] = useState('')

    const [isSendingEmail, setIsSendingEmail] = useState(false)


    useEffect(() => {
        getProviders().then((ps: any) => {
            setProviders(ps)
        })
    }, [])


    const [email, setEmail] = useState('');
    const [showVerificationStep, setShowVerificationStep] = useState(false);
    const emailProvider = Object.values(providers).filter(
        (provider) => provider.type === 'email'
    );

    const [loading, setLoading] = useState(false)

    const [stage, setStage] = useState(0)


    const handleSignin = useCallback(async () => {
        console.log(`sengind you an otp for ${email}`)

        setStage(1);
        const res = await signIn('email', {
            email: email,
            redirect: false,
        });


        setStage(2);

        if (isNil(res) || res.error) {
            setStage(0)
        }

        // if (res?.error) {
        //     if (res?.url) {
        //         window.location.replace(res.url);
        //         setStage(0);
        //     }   
        // } else {
        //     // onSuccess(email);
        // }
    }, [email]);

    // right after user has put 6 otp inside, go for verification
    const [isVerifying, setIsVerifying] = useState(false)



    useEffect(() => {
        if (otp.length != 6) return

        // send otp to backend
        setIsVerifying(true)

        console.log("welcome/ running callback url")
        setTimeout(() => {
            window.location.href = `/api/auth/callback/email?email=${encodeURIComponent(
                email
            )}&token=${otp}${process.env.AUTH_URL ? `&callbackUrl=${process.env.AUTH_URL }` : ''}`;

        }, 2000)


    }, [otp, email])


    return (
        <main className="">

            <section className="#first ml-8  mt-[150px]  self-start">
                <h1 className="text-6xl font-bold tracking-tight delay-500 sm:text-8xl text-black">
                    {" "}
                    Welcome to
                </h1>
                <h1 className="text-6xl font-bold tracking-tight delay-500 sm:text-8xl text-black">
                    <mark className="bg-transparent font-extrabold text-stone-800 shadow-[inset_0_-0.5em_0_0_rgb(240,171,10)]">
                        AnataLAB
                    </mark>
                </h1>

                <h1 className="text-sm  font-mono tracking-tight delay-500 sm:text-4xl text-black/50 mt-12 w-2/3">
                    {"Let's setup your new account first, all your created formulas will be stored here."}
                </h1>

            </section>

            <section className="ml-8 mb-20">
                <div className={cn("text-center my-4 h-24 items-center flex flex-row rounded-xl p-2 w-2/3 space-x-4",
                    stage === 0 && "bg-black",
                    stage === 1 && "bg-yellow-600",
                    stage === 2 && "bg-green-600",
                )}>
                    <motion.input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="h-full w-full border rounded-xl p-4"
                        placeholder="Your email here"
                    />
                    <button
                        onClick={async () => {
                            await handleSignin()
                        }}
                        className="h-full w-24 transition duration-300 flex flex-row items-center justify-center hover:bg-green-800 rounded-xl"
                        disabled={stage != 0}
                    >

                        {stage == 0 && (
                            <div className="flex items-center justify-center">
                                <FaArrowRightToBracket className="h-5 w-5 text-white" />
                            </div>

                        )}
                        {stage == 1 && (
                            <div className="flex items-center justify-center">
                                <div className="animate-spin">
                                    <FaSpinner className="animate-spin h-5 w-5 text-white" />
                                </div>
                            </div>
                        )}
                        {stage == 2 && (
                            <div className="flex items-center justify-center">
                                <div className="">
                                    <FaCheck className="h-5 w-5 text-white" />
                                </div>
                            </div>
                        )}


                    </button>
                </div>

                {stage == 2 && (
                    <div className="w-fit">
                        <p className="font-mono">{"Enter the 6-digit code we sent to your email"}</p>
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.5 }}
                            className={cn(
                                "flex flex-row items-center justify-center rounded-xl h-24",
                                otp.length === 6 ? "bg-green-600" : "bg-black",

                            )}
                        >


                            <InputOTP
                                maxLength={6}
                                pattern={REGEXP_ONLY_DIGITS}
                                value={otp}
                                onChange={setOtp}
                                className='w-full h-full'
                            >
                                <InputOTPGroup>
                                    <InputOTPSlot index={0} className='bg-white text-blac font-bold text-xl size-16' />
                                    <InputOTPSlot index={1} className='bg-white text-blac font-bold text-xl size-16' />
                                    <InputOTPSlot index={2} className='bg-white text-blac font-bold text-xl size-16' />
                                    <InputOTPSlot index={3} className='bg-white text-blac font-bold text-xl size-16' />
                                    <InputOTPSlot index={4} className='bg-white text-blac font-bold text-xl size-16' />
                                    <InputOTPSlot index={5} className='bg-white text-blac font-bold text-xl size-16' />
                                </InputOTPGroup>
                            </InputOTP>


                            {otp.length == 6 && (
                                <div className="flex items-center justify-center">
                                    <div className="p-8 animate-spin">
                                        <FaSpinner className="animate-spin h-5 w-5 text-white" />
                                    </div>
                                </div>
                            )}

                        </motion.div>
                    </div>

                )}



            </section>
        </main>
    )


    return (
        <div className="#page mt-20 flex flex-col items-center justify-center h-full">
            <div className="flex flex-grow flex-col gap-4    p-10 bg-black"
                style={{ backgroundColor: 'radial-gradient( 20% 20% at 100% 70%, var(--hero-orange) 10%, transparent 200%), radial-gradient(20% 25% at 60% 80%, var(--hero-red) 10%, transparent 300%), radial-gradient( circle farthest-side at 90% 40%, var(--hero-green) 30%, transparent 80%), radial-gradient(circle farthest-corner at top left, var(--hero-dark-blue) 30%, transparent 80%)' }}
            >

                <p
                    className="font-mono text-3xl font-bold ">

                    Welcome to AnataLAB
                </p>

                <p
                    className="font-mono text-black">

                    {"Let's get you signed in, what is your email?"}
                </p>



            </div>

            {/* {emailProvider.map((provider) => (
                <EmailInput
                    key={provider.id}
                    provider={provider as any}
                    onSuccess={(email) => {
                        setEmail(email);
                        setShowVerificationStep(true);
                    }}
                />
            ))} */}

            {/* {credentials} */}
        </div>
    );
};

// SigninPage.getInitialProps = async (context) => {
//     const { req } = context;
//     const session = await getSession({ req });
//     return {
//         isLoggedIn: session !== null,
//         providers: await getProviders(),
//     } as unknown as SigninPageProps;
// };

export default SigninPage;